<template>
  <div class="age-tip">
<!--    <header-tip style="margin: 2px 0;">-->
<!--      <slot name="start" v-bind="{age_list:target_list,money:targetMoney}"></slot>-->
<!--    </header-tip>-->

      <header-tip style="margin: 2px 0;">
        <table class="age-tip-table" cellspacing="0" cellpadding="0">
          <template v-for="(item) in target_list">
            <tr class="age-tip-item">
              <td class="age-tip-item-item">{{ageText[item.type]}}</td>
              <td class="age-tip-item-item">收缴率计划：{{item.target_rate}}%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td class="age-tip-item-item">实际：{{item.receipt_rate}}%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td class="age-tip-item-item">差异：{{ item.cut_rate }}%&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td class="age-tip-item-item">当月催缴目标：{{formatMoney(item.target_money/10000,2)}} 万元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td class="age-tip-item-item">当月实收：{{formatMoney(item.receipt_money/10000,2)}} 万元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
              <td class="age-tip-item-item">差异：{{ formatMoney((item.receipt_money-item.target_money)/10000,2) }} 万元&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            </tr>
          </template>
        </table >

      </header-tip>


  </div>
</template>

<script>
import HeaderTip from "../../../Common/header-tip";
import moment from "moment";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
import {isArray} from "lodash";
export default {
  name: "AgeTip",
  components: {HeaderTip},
  props: {
    urge_type:{
      type: Number,
      default(){
        return 0
      }
    },
    ages:{
      type: Array|String|Number,
      default(){
        return []
      }
    },
    project_id:{
      type: Number|String,
      default: 0
    },
    project_ids:{
      type: Array|String,
      default(){
        return []
      }
    },
    yearmonth:{
      type: String,
      default(){
        return moment().format("YYYY-MM")
      }
    }
  },
  data() {
    return {
      ageText:{
        1: "当期",
        2: "纯上一年",
        3: "一年以上两年以内",
        4: "两年以上",
        5: "一年以上",
        6: "历史",
      },
      target_list:[],
      houseTypeCurrent:{},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getProjectTarget(){
      const that=this;
      let ages="1,2,3,4";
      if(this.ages){
        if(typeof this.ages === "string") {
          ages=this.ages;
        }else if(typeof this.ages === "number") {
          ages=this.ages;
        }else if(isArray(this.ages)&&this.ages.length!==0&&this.ages[0]){
          ages=this.ages.join(",");
        }
      }
      ButlerHttp.post("FinanceTarget/getProjectTarget",{
        project_ids: that.project_ids,
        project_id: that.project_id,
        yearmonth: that.yearmonth,
        ages: ages
      },ret=>{
        if(ret.code===200){
          that.target_list=ret.data;
        }else {
          that.target_list=[]
        }
      })
    },
    getProjectAnalysis(){
      const that=this;
      let ages="1,2,3,4";
      if(this.ages){
        if(typeof this.ages === "string") {
          ages=this.ages;
        }else if(typeof this.ages === "number") {
          ages=this.ages;
        }else if(isArray(this.ages)&&this.ages.length!==0&&this.ages[0]){
          ages=this.ages.join(",");
        }
      }
      ButlerHttp.post("https://api.oa.gdzawy.com:9001/admin/Statics/getProjectAnalysis",{
        project_ids: that.project_id?that.project_id:that.project_ids,
        month: that.yearmonth?that.yearmonth.replace("-",''):moment().format("YYYYMM"),
        order_type: ages
      },ret=>{
        if(ret.code===200){
          that.target_list=ret.data;
        }else {
          that.target_list=[]
        }
      })
    },
    getUseLegalHouseTypeCurrent(){
      const that = this;
      let ages="1,2,3,4";
      if(this.ages){
        if(typeof this.ages === "string") {
          ages=this.ages;
        }else if(typeof this.ages === "number") {
          ages=this.ages;
        }else if(isArray(this.ages)&&this.ages.length!==0&&this.ages[0]){
          ages=this.ages.join(",");
        }
      }
      let where = {
        urge_type:that.urge_type,
        project_ids:that.project_ids,
        project_id:that.project_id,
        jh_time:that.yearmonth?that.yearmonth:moment().format("YYYY-MM"),
        ages:ages
      }

      ButlerHttp.post("LegalHouse/getUseLegalHouseTypeCurrent",{
        ...where
      }, res => {
        if (res.code) {
          (res.data||[]).forEach(ret=>{
            that.houseTypeCurrent[ret.type_current]=ret
          })
        }
      });
    },
    toRound(val,num=2){
      return Math.round(val*Math.pow(10,num))/Math.pow(10,num)
    },
    getData(){
      this.getProjectAnalysis()
      this.getUseLegalHouseTypeCurrent();
    }
  },
  watch:{
    yearmonth(n,o){
      const that=this;
      CommonHelp.debounce(function () {
        that.getData();
      },500,that);
    },
    ages(n,o){
      const that=this;
      CommonHelp.debounce(function () {
        that.getData();
      },500,that);
    },
    project_id(n,o){
      const that=this;
      CommonHelp.debounce(function () {
        that.getData();
      },500,that);
    },
    project_ids(n,o){
      const that=this;
      CommonHelp.debounce(function () {
        that.getData();
      },500,that);
    },
  }
}
</script>

<style lang="scss" scoped>
.age-tip{
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .age-tip-table{
    border: 0;
    .age-tip-item{
      //display: flex;
      //flex-direction: row;
      //justify-content: flex-start;

      .age-tip-item-item{
        min-width: 120px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/common/AgeTip.vue